export default __webpack_public_path__ + "a0ad206968bfe69f7fd28937c69b738c.jpg";